import {
    GET_CMS_SITE_SECONDARY_NAV,
    GET_CMS_SITE_SECONDARY_NAV_ERROR,
} from "./types";
import CMSService from "../../services/cms.service";

export function getSecondaryNavContent() {
    return function (dispatch) {
        try {
            return CMSService.reqSecondaryNav()
                .then((data) => {
                    dispatch(
                        {
                            type: GET_CMS_SITE_SECONDARY_NAV,
                            payload: data.data
                        })
                });
        }
        catch (error) {
            return (dispatch) => {
                dispatch({
                    type: GET_CMS_SITE_SECONDARY_NAV_ERROR,
                });
            }
        }
    };
}